import { NullableSettingConfig } from "./NullableSettingConfig";
import { Dictionary } from "./Dictionary";

export const NullableDictionarySetting: NullableSettingConfig<Dictionary> = {
  type: "dictionary",
  serialize: (value: Dictionary | null): string | null => {
    return value == null ? value : JSON.stringify(value);
  },

  deserialize: (value: string | null): Dictionary | null => {
    return value == null ? null : JSON.parse(value);
  },
};
